/** Shared control geometry. Tailwind's `border` is the 1px hairline width token. */
export type ControlSize = 'default' | 'toolbar' | 'compact';
export type ControlDensity = 'productive' | 'comfort';

export const controlFrameClassName = 'border rounded-control font-body font-semibold leading-tight';

export const controlSizeClasses = {
  default: 'h-11 min-h-11 px-4 py-2 text-body',
  toolbar: 'h-9 min-h-9 px-3 py-2 text-body',
  compact: 'h-8 min-h-8 px-2 py-1 text-caption',
} satisfies Record<ControlSize, string>;

export const comfortControlClassName =
  'h-12 min-h-12 rounded-control-comfort px-4 py-2 text-body-comfort';

export function controlSizeClassName(
  size: ControlSize = 'default',
  density: ControlDensity = 'productive',
) {
  return density === 'comfort' ? comfortControlClassName : controlSizeClasses[size];
}
